import { render, staticRenderFns } from "./BrowseOverview.vue?vue&type=template&id=f6439d04&scoped=true"
import script from "./BrowseOverview.vue?vue&type=script&lang=js"
export * from "./BrowseOverview.vue?vue&type=script&lang=js"
import style0 from "./BrowseOverview.vue?vue&type=style&index=0&id=f6439d04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6439d04",
  null
  
)

export default component.exports